export const safeDispatch = event => global?.dataLayer?.push?.(event);

export default {
  sendSaveOpenHouseEvent: ({ openHouseId }) => {
    safeDispatch({
      event: "custom_event",
      event_category: "save",
      event_action: "openhouse",
      event_label: openHouseId
    });
  },
  sendUnsaveOpenHouseEvent: ({ openHouseId }) => {
    safeDispatch({
      event: "custom_event",
      event_category: "unsave",
      event_action: "openhouse",
      event_label: openHouseId
    });
  },
  sendAddToCalendarEvent: ({ openHouseId }) => {
    safeDispatch({
      event: "custom_event",
      event_category: "openhouse",
      event_action: "add_to_calendar",
      event_label: openHouseId
    });
  },
  sendViewOpenhouseEvent: ({
    recentNumberOpenHouses,
    upcomingNumberOpenHouses
  }) => {
    safeDispatch({
      event: "custom_event",
      event_category: "openhouse",
      event_action: "view_openhouse",
      event_label: `upcoming=${upcomingNumberOpenHouses}|past=${recentNumberOpenHouses}`
    });
  },
  sendSelfReportAttendedEvent: ({ answer, id }) => {
    safeDispatch({
      event: "custom_event",
      event_category: "openhouse",
      event_action: "attended",
      event_label: `${answer}|item_id=${id}`
    });
  }
};
